export const CONST = {
  DEBOUNCE_TIME: 200,
  BREAKPOINTS: {
    small: '749px',
    medium: '1249px',
    large: '1875px',
  }
};
